// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Base */
.Header_header__LARkX {
  position: fixed;
  width: 100%;
  background-color: transparent;
  z-index: 9999;
  transition: background-color 0.3s ease;
}

.Header_header__LARkX.Header_scrolled__oWZsc {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Drawer Overlay */
.Header_drawerOverlay__cWHqR {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 48;
}

.Header_drawerOverlay__cWHqR.Header_open__B1Laz {
  opacity: 1;
  visibility: visible;
}

/* Navigation Container & Content */
.Header_navContainer__BvA3T {
  padding: 1rem;
  z-index: 9999 !important;
}

.Header_navContent__tKIcI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 100;
}

/* Logo Styles */
.Header_logo__v3Ggk {
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
}

.Header_logoPic__z0VVp {
  height: 45px;
  width: auto;
  cursor: pointer;
}

/* Desktop Navigation */
.Header_desktopNav__k-wwr {
  display: none;
}

.Header_navItem__nmyhK {
  color: white;
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: none;
    padding-bottom: 0.25rem;
    position: relative;
    transition: border-bottom 0.2sease;
    font-weight: 600;
    font-size: 1rem;
}

.Header_navItem__nmyhK:hover,
.Header_navItem__nmyhK.Header_active__-cPLN {
  border-bottom: 2px solid white;
}

/* Dropdown */
.Header_dropdown__N7xMN {
  position: relative;
}

.Header_dropdownButton__C7B4M {
  display: flex;
  align-items: baseline;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  padding-bottom: 0.25rem;
  transition: border-bottom 0.2s ease;
  font-size: 1rem;
  font-weight: 600;
  z-index: 100;
}

.Header_dropdownButton__C7B4M:hover,
.Header_dropdownButton__C7B4M.Header_active__-cPLN {
  border-bottom: 2px solid white;
}

.Header_dropdownContent__kHF2g {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.5rem;
  width: 12rem;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.375rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease;
  z-index: 100;
}

.Header_dropdownContent__kHF2g.Header_active__-cPLN {
  opacity: 1;
  transform: translateY(0);
}

.Header_dropdownItem__2Qt7N {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.5rem 1rem;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.Header_dropdownItem__2Qt7N:hover,
.Header_dropdownItem__2Qt7N.Header_active__-cPLN {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Icons Container */
.Header_iconsContainer__ymYI\\+ {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.Header_iconButton__M3wlM {
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

/* Mobile Menu Button */
.Header_mobileMenuButton__0VVxU {
  display: block;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
}

/* Mobile Menu */
.Header_mobileMenu__GbYM9 {
  margin-top: 1rem;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.9);
  border-radius: 0.5rem;
  padding: 1rem;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  backdrop-filter: blur(10px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}

.Header_mobileMenu__GbYM9.Header_active__-cPLN {
  opacity: 1;
  transform: translateY(0);
}

.Header_mobileNavItem__13YYL {
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0;
  transition: color 0.2s ease;
}

.Header_mobileNavItem__13YYL:hover,
.Header_mobileNavItem__13YYL.Header_active__-cPLN {
  color: #d1d5db;
}

.Header_mobileDropdownContent__2AXm4 {
  padding-left: 1rem;
  margin-top: 0.5rem;
}

.Header_mobileDropdownItem__vT1pW {
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0;
  transition: color 0.2s ease;
}

.Header_mobileDropdownItem__vT1pW:hover,
.Header_mobileDropdownItem__vT1pW.Header_active__-cPLN {
  color: #d1d5db;
}

.Header_chevronIcon__KF4rc {
  margin-left: 0.25rem;
  width: 1rem;
  height: 1rem;
  position: relative;
  top: 4px;
}

/* User Drawer */
.Header_userDrawer__Nl5dK {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  backdrop-filter: blur(10px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateX(100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 49;
  overflow-y: auto;  /* Ensures the drawer scrolls on smaller screens */
}

@media (min-width: 640px) {
  .Header_userDrawer__Nl5dK {
    width: 400px;
  }
}

.Header_userDrawer__Nl5dK.Header_open__B1Laz {
  transform: translateX(0);
}

.Header_closeDrawer__WojXw {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  z-index: 100; /* Added z-index to bring the button on top */
}

.Header_closeDrawer__WojXw:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Drawer Content */
.Header_drawerContent__-oZoL {
  height: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* User Info */
.Header_userInfo__XIA27 {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 3rem;
}

.Header_userAvatar__Llv9\\+ {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.Header_userDetails__M8DHf {
  flex: 1 1;
}

.Header_userDetails__M8DHf h3 {
  color: white;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.5px;
}

.Header_userDetails__M8DHf p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  margin: 0.25rem 0 0 0;
}

/* Drawer Menu */
.Header_drawerMenu__Nb3Oq {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Header_drawerMenu__Nb3Oq li {
  padding: 1rem 1.5rem;
  color: white;
  cursor: pointer;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.Header_drawerMenu__Nb3Oq li:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(5px);
}

/* Sign Out Option */
.Header_signOutItem__Wwz\\+7 {
  margin-top: auto;
  color: #ff4444 !important;
  border-color: rgba(255, 68, 68, 0.2) !important;
}

.Header_signOutItem__Wwz\\+7:hover {
  background: rgba(255, 68, 68, 0.1) !important;
}

/* Loading Icon */
.Header_loadingWrapper__coRF2 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.Header_loadingIcon__NgyfZ {
  animation: Header_spin__4he-t 1s linear infinite;
}

@keyframes Header_spin__4he-t {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Media Queries */

/* For devices wider than 768px (desktop/tablet landscape) */
@media (min-width: 768px) {
  .Header_navContainer__BvA3T {
    padding: 1rem 2rem;
    z-index: 9999 !important;
  }

  .Header_desktopNav__k-wwr {
    display: flex;
    align-items: center;
    gap: 2rem;
  }

  .Header_mobileMenuButton__0VVxU {
    display: none;
  }
}

/* For devices with width 639px and below (small tablets/phones) */
@media (max-width: 639px) {
  .Header_drawerContent__-oZoL {
    padding: 1.5rem;
  }

  .Header_userInfo__XIA27 {
    margin-top: 2rem;
    padding: 1rem;
  }

  .Header_userAvatar__Llv9\\+ {
    width: 48px;
    height: 48px;
  }

  .Header_userDetails__M8DHf h3 {
    font-size: 1.125rem;
  }

  .Header_userDetails__M8DHf p {
    font-size: 0.875rem;
  }

  .Header_drawerMenu__Nb3Oq li {
    padding: 0.875rem 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/common/UI/CSS/Header.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,YAAY;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,0CAA0C;EAC1C,0CAA0C;EAC1C,uBAAuB;EACvB,wCAAwC;EACxC,iBAAiB;EACjB,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,wFAAwF;EACxF,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,wFAAwF;EACxF,2BAA2B;EAC3B,+CAA+C;EAC/C,2BAA2B;EAC3B,uDAAuD;EACvD,WAAW;EACX,gBAAgB,GAAG,kDAAkD;AACvE;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,YAAY,EAAE,6CAA6C;AAC7D;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wFAAwF;EACxF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;;AAElB,4DAA4D;AAC5D;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Header Base */\n.header {\n  position: fixed;\n  width: 100%;\n  background-color: transparent;\n  z-index: 9999;\n  transition: background-color 0.3s ease;\n}\n\n.header.scrolled {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n/* Drawer Overlay */\n.drawerOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 48;\n}\n\n.drawerOverlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Navigation Container & Content */\n.navContainer {\n  padding: 1rem;\n  z-index: 9999 !important;\n}\n\n.navContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 100;\n}\n\n/* Logo Styles */\n.logo {\n  color: white;\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n.logoPic {\n  height: 45px;\n  width: auto;\n  cursor: pointer;\n}\n\n/* Desktop Navigation */\n.desktopNav {\n  display: none;\n}\n\n.navItem {\n  color: white;\n    background: none;\n    border: none;\n    cursor: pointer;\n    text-decoration: none;\n    padding-bottom: 0.25rem;\n    position: relative;\n    transition: border-bottom 0.2sease;\n    font-weight: 600;\n    font-size: 1rem;\n}\n\n.navItem:hover,\n.navItem.active {\n  border-bottom: 2px solid white;\n}\n\n/* Dropdown */\n.dropdown {\n  position: relative;\n}\n\n.dropdownButton {\n  display: flex;\n  align-items: baseline;\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding-bottom: 0.25rem;\n  transition: border-bottom 0.2s ease;\n  font-size: 1rem;\n  font-weight: 600;\n  z-index: 100;\n}\n\n.dropdownButton:hover,\n.dropdownButton.active {\n  border-bottom: 2px solid white;\n}\n\n.dropdownContent {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 0.5rem;\n  width: 12rem;\n  backdrop-filter: blur(8px);\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 0.375rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 0.5rem 0;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.2s ease;\n  z-index: 100;\n}\n\n.dropdownContent.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.dropdownItem {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem 1rem;\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.2s ease;\n}\n\n.dropdownItem:hover,\n.dropdownItem.active {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n/* Icons Container */\n.iconsContainer {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.iconButton {\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n/* Mobile Menu Button */\n.mobileMenuButton {\n  display: block;\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n/* Mobile Menu */\n.mobileMenu {\n  margin-top: 1rem;\n  backdrop-filter: blur(8px);\n  background-color: rgba(0, 0, 0, 0.9);\n  border-radius: 0.5rem;\n  padding: 1rem;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.2s ease;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));\n  backdrop-filter: blur(10px);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mobileMenu.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.mobileNavItem {\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem 0;\n  transition: color 0.2s ease;\n}\n\n.mobileNavItem:hover,\n.mobileNavItem.active {\n  color: #d1d5db;\n}\n\n.mobileDropdownContent {\n  padding-left: 1rem;\n  margin-top: 0.5rem;\n}\n\n.mobileDropdownItem {\n  color: white;\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  padding: 0.5rem 0;\n  transition: color 0.2s ease;\n}\n\n.mobileDropdownItem:hover,\n.mobileDropdownItem.active {\n  color: #d1d5db;\n}\n\n.chevronIcon {\n  margin-left: 0.25rem;\n  width: 1rem;\n  height: 1rem;\n  position: relative;\n  top: 4px;\n}\n\n/* User Drawer */\n.userDrawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));\n  backdrop-filter: blur(10px);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  transform: translateX(100%);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 49;\n  overflow-y: auto;  /* Ensures the drawer scrolls on smaller screens */\n}\n\n@media (min-width: 640px) {\n  .userDrawer {\n    width: 400px;\n  }\n}\n\n.userDrawer.open {\n  transform: translateX(0);\n}\n\n.closeDrawer {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n  z-index: 100; /* Added z-index to bring the button on top */\n}\n\n.closeDrawer:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Drawer Content */\n.drawerContent {\n  height: 100%;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* User Info */\n.userInfo {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  padding: 1.5rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 3rem;\n}\n\n.userAvatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.userDetails {\n  flex: 1;\n}\n\n.userDetails h3 {\n  color: white;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n.userDetails p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.95rem;\n  margin: 0.25rem 0 0 0;\n}\n\n/* Drawer Menu */\n.drawerMenu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.drawerMenu li {\n  padding: 1rem 1.5rem;\n  color: white;\n  cursor: pointer;\n  border-radius: 0.75rem;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.drawerMenu li:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateX(5px);\n}\n\n/* Sign Out Option */\n.signOutItem {\n  margin-top: auto;\n  color: #ff4444 !important;\n  border-color: rgba(255, 68, 68, 0.2) !important;\n}\n\n.signOutItem:hover {\n  background: rgba(255, 68, 68, 0.1) !important;\n}\n\n/* Loading Icon */\n.loadingWrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.loadingIcon {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Media Queries */\n\n/* For devices wider than 768px (desktop/tablet landscape) */\n@media (min-width: 768px) {\n  .navContainer {\n    padding: 1rem 2rem;\n    z-index: 9999 !important;\n  }\n\n  .desktopNav {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n  }\n\n  .mobileMenuButton {\n    display: none;\n  }\n}\n\n/* For devices with width 639px and below (small tablets/phones) */\n@media (max-width: 639px) {\n  .drawerContent {\n    padding: 1.5rem;\n  }\n\n  .userInfo {\n    margin-top: 2rem;\n    padding: 1rem;\n  }\n\n  .userAvatar {\n    width: 48px;\n    height: 48px;\n  }\n\n  .userDetails h3 {\n    font-size: 1.125rem;\n  }\n\n  .userDetails p {\n    font-size: 0.875rem;\n  }\n\n  .drawerMenu li {\n    padding: 0.875rem 1.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__LARkX`,
	"scrolled": `Header_scrolled__oWZsc`,
	"drawerOverlay": `Header_drawerOverlay__cWHqR`,
	"open": `Header_open__B1Laz`,
	"navContainer": `Header_navContainer__BvA3T`,
	"navContent": `Header_navContent__tKIcI`,
	"logo": `Header_logo__v3Ggk`,
	"logoPic": `Header_logoPic__z0VVp`,
	"desktopNav": `Header_desktopNav__k-wwr`,
	"navItem": `Header_navItem__nmyhK`,
	"active": `Header_active__-cPLN`,
	"dropdown": `Header_dropdown__N7xMN`,
	"dropdownButton": `Header_dropdownButton__C7B4M`,
	"dropdownContent": `Header_dropdownContent__kHF2g`,
	"dropdownItem": `Header_dropdownItem__2Qt7N`,
	"iconsContainer": `Header_iconsContainer__ymYI+`,
	"iconButton": `Header_iconButton__M3wlM`,
	"mobileMenuButton": `Header_mobileMenuButton__0VVxU`,
	"mobileMenu": `Header_mobileMenu__GbYM9`,
	"mobileNavItem": `Header_mobileNavItem__13YYL`,
	"mobileDropdownContent": `Header_mobileDropdownContent__2AXm4`,
	"mobileDropdownItem": `Header_mobileDropdownItem__vT1pW`,
	"chevronIcon": `Header_chevronIcon__KF4rc`,
	"userDrawer": `Header_userDrawer__Nl5dK`,
	"closeDrawer": `Header_closeDrawer__WojXw`,
	"drawerContent": `Header_drawerContent__-oZoL`,
	"userInfo": `Header_userInfo__XIA27`,
	"userAvatar": `Header_userAvatar__Llv9+`,
	"userDetails": `Header_userDetails__M8DHf`,
	"drawerMenu": `Header_drawerMenu__Nb3Oq`,
	"signOutItem": `Header_signOutItem__Wwz+7`,
	"loadingWrapper": `Header_loadingWrapper__coRF2`,
	"loadingIcon": `Header_loadingIcon__NgyfZ`,
	"spin": `Header_spin__4he-t`
};
export default ___CSS_LOADER_EXPORT___;
